import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ContextMenuPanel = _resolveComponent("ContextMenuPanel")!

  return (_openBlock(), _createBlock(_component_ContextMenuPanel, { ref: "panel" }, {
    buttons: _withCtx(() => [
      _renderSlot(_ctx.$slots, "buttons")
    ]),
    _: 3
  }, 512))
}